/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AppSecopsApplicationResponse extends models.AppSecopsApplication {
    getFixupPrototypeFunction() { return AppSecopsApplicationResponse.fixupPrototype; }

    static newInstance(model: Partial<AppSecopsApplicationResponse>): AppSecopsApplicationResponse {
        let obj = Object.assign(new AppSecopsApplicationResponse(), model);
        AppSecopsApplicationResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AppSecopsApplicationResponse>): AppSecopsApplicationResponse {
        if (!model) return null;
        return AppSecopsApplicationResponse.newInstance(<AppSecopsApplicationResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AppSecopsApplicationResponse) {
        if (!obj) return;

        models.AppSecopsApplicationResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AppSecopsApplicationResponse): boolean {
        if (models.AppSecopsApplication.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AppSecopsApplicationResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
